<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title">{{ pageTitle }}</h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content">
        <div class="m-portlet m-portlet--full-height  ">
          <div class="tab-content">
            <div class="">
              <div class="m-form m-form--fit m-form--label-align-right">
                <div class="m-portlet__body">
                  <div v-if="!user.set_password" class="form-group m-form__group row">
                    <label for="old-password" class="col-5 col-md-2 col-form-label">Obecne hasło</label>
                    <div class="col-7">
                      <b-form-input id="old-password" :state="currentPasswordState" type="password"
                                    aria-describedby="currentPasswordFeedback"
                                    v-model="currentPassword"></b-form-input>
                      <b-form-invalid-feedback id="currentPasswordFeedback">
                        Musisz podać obecne hasło
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group m-form__group row">
                    <label for="new-password" class="col-5 col-md-2 col-form-label">Nowe hasło</label>
                    <div class="col-7">
                      <password-input v-model="newPassword" id="new-password"
                                      @invalid="newPasswordState = false"
                                      @valid="newPasswordState = true"></password-input>
                    </div>
                  </div>
                  <div class="form-group m-form__group row">
                    <label for="repeat-new-password" class="col-5 col-md-2 col-form-label">Powtórz nowe hasło</label>
                    <div class="col-7">
                      <b-form-input id="repeat-new-password" :state="repeatNewPasswordState" type="password"
                                    aria-describedby="repeatNewPasswordFeedback"
                                    v-model="repeatNewPassword"></b-form-input>
                      <b-form-invalid-feedback id="repeatNewPasswordFeedback">
                        Podane hasła nie są identyczne
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </div>
                <div class="m-portlet__foot m-portlet__foot--fit">
                  <div class="m-form__actions">
                    <div class="row">
                      <div class="col-12">
                        <b-button class="m-btn m-btn--air btn-ls"
                                  :disabled="disableSaveButton"
                                  @click="changePassword">Zapisz zmiany
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import {mapState} from 'vuex';
import PasswordInput from "../input/PasswordInput";
import Page from "./Page";

export default {
  name: "ChangePasswordPage",
  components: {Page, PasswordInput},
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      repeatNewPassword: '',
      newPasswordState: false
    }
  },
  methods: {
    changePassword() {
      if (this.currentPasswordState === true && this.repeatNewPasswordState === true) {
        this.$http.patch('password/change', {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword
        })
            .then(() => {
              this.currentPassword = '';
              this.newPassword = '';
              this.repeatNewPassword = '';
            });
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    currentPasswordState() {
      if (this.user.set_password) {
        return true; // external auth user has to set password first
      }

      if (!this.currentPassword.length && !this.newPassword.length && !this.repeatNewPassword.length) {
        return null
      }

      if (this.currentPassword.length > 0) {
        return true
      }

      return !(!this.currentPassword.length && this.newPassword.length || this.repeatNewPassword);
    },
    repeatNewPasswordState() {
      if (!this.repeatNewPassword.length) {
        return null
      }

      return this.newPassword === this.repeatNewPassword;
    },
    disableSaveButton() {
      return !(this.currentPasswordState && this.repeatNewPasswordState && this.newPasswordState)
    },
    pageTitle() {
      return this.user.set_password ? 'Ustaw hasło' : 'Zmień hasło';
    }
  }
}
</script>

<style scoped>
@media (max-width: 769px) {
  .m-form__group {
    padding-bottom: 0 !important;
  }
}
</style>
